import * as React from "react";
import SisStartImport from ".";

const OneRosterStartImport = (props): React.ReactElement => {
  return (
    <SisStartImport
      {...props}
      type="staff-records"
      includeSchools={true}
      enableAskImportPopUp={true}
      translateConfigEndPoint={'data-ingest/sis/parameter-group/staff-recordstranslateConfig'}
    />
  );
};

export default OneRosterStartImport;